var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flex-items-xs-center flex-items-md-left"},[_c('sdx-loading-spinner',{staticClass:"col-xs-auto",attrs:{"size":"large"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }